/* Terminal Window */
.terminal {
  position: absolute;
  background: var(--color-surface);
  border: var(--border-medium) var(--border-style) var(--color-border-strong);
  border-radius: var(--radius-window);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  will-change: transform;
  display: flex;
  flex-direction: column;
  animation: windowOpen 0.3s ease-out;
  transform-origin: center center;
}

.terminal.dragging {
  cursor: grabbing;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
}

.terminal.maximized {
  border-radius: 0;
}

@keyframes windowOpen {
  from {
    opacity: 0;
    scale: 0.95;
  }
  to {
    opacity: 1;
    scale: 1;
  }
}

.terminal.closing {
  animation: windowClose 0.2s ease-in forwards;
  pointer-events: none;
}

@keyframes windowClose {
  from {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 0.95;
  }
}

.terminalHeader {
  background: var(--color-surface-raised);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
  padding: var(--space-2) var(--space-3);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  cursor: grab;
  user-select: none;
  touch-action: none;
}

.terminal.dragging .terminalHeader {
  cursor: grabbing;
}

.terminalTitle {
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  color: var(--color-text-muted);
  margin-left: auto;
}

.terminalBody {
  padding: var(--space-4);
  font-family: var(--font-mono);
  font-size: var(--body-size);
  flex: 1;
  overflow: auto;
}

.terminalLine {
  line-height: 1.1;
  white-space: pre-wrap;
}

.terminalLine.command {
  color: var(--color-success);
}

.terminalLine.output {
  color: var(--color-text);
}

.terminalLine.error {
  color: var(--color-error, #ff6b6b);
}

.cursor {
  color: var(--color-text);
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.inputLine {
  display: flex;
  align-items: center;
}

.terminalInput {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: var(--color-success);
  font-family: var(--font-mono);
  font-size: inherit;
  padding: 0;
  margin: 0;
  caret-color: var(--color-text);
}

.terminalInput:focus-visible {
  outline: none;
}

.terminalInput::selection {
  background: var(--color-text);
  color: var(--color-surface);
}
